import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { isNativeApp } from './lib/api';
import { watchKeyboard } from './lib/keyboard';
import { loadLang, useLang } from './lib/i18n';
// Poppins ships inside the app: no Google Fonts request on start-up, no text jumping when it arrives.
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
// Poppins covers English and Hindi (Devanagari); Tamil comes from Hind Madurai, by the same foundry.
import '@fontsource/hind-madurai/tamil-400.css';
import '@fontsource/hind-madurai/tamil-500.css';
import '@fontsource/hind-madurai/tamil-600.css';
import '@fontsource/hind-madurai/tamil-700.css';
import './index.css';

watchKeyboard();

// Tamil / Hindi: load the language's table before the first screen, so nothing flashes in English.
void loadLang(useLang.getState().lang).catch(() => {}).finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});

// The native app ships its files inside the APK, so it needs no service worker.
if ('serviceWorker' in navigator && import.meta.env.PROD && !isNativeApp()) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
}
